"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationResultRequest = void 0;
var ApplicationResultRequest = /** @class */ (function () {
    function ApplicationResultRequest() {
    }
    return ApplicationResultRequest;
}());
exports.ApplicationResultRequest = ApplicationResultRequest;
;
//# sourceMappingURL=applicationResult.request.js.map